const numberFormatter = new Intl.NumberFormat("en-US");

/** "48,300" — the grouped form every counter in the cabinet uses. */
export const formatCount = (value: number): string => numberFormatter.format(value);

/**
 * Bar width for a used/limit pair. Unlimited tools have no bar to fill, so they
 * report 0 and the caller hides the bar instead.
 */
export const usagePercent = (percent: number | null): number => Math.min(100, Math.max(0, percent ?? 0));
